import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import Header from "../../Components/Header";
import { useLocation } from "react-router-dom";

const SeatLayout = () => {
    const location = useLocation();
    const { seatData, busData } = location.state || {};
    const [loading] = useState(false);

    const bus = busData;

    //  Helpers
    const formatTime = (time) =>
        time
            ? new Date(time).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
            })
            : "--:--";

    const formatDate = (time) =>
        time ? new Date(time).toDateString() : "";

    //  Safety check
    if (!seatData || !seatData.seats) {
        return <p>No seat data available</p>;
    }

    //  Split decks
    const lowerDeck = seatData.seats.filter((s) => s.z === 0);
    const upperDeck = seatData.seats.filter((s) => s.z === 1);

    const fare = bus?.fares?.[0] || {};
    const policy = bus?.policy?.cancel || [];

    return (
        <div>
            <section class="Booking_flight">
                <div class="container_box mt-3">
                    {loading && (
                        <p className="text-center load">
                            <span className="loader"></span>
                        </p>
                    )}

                    <Header />
                    <div className="row">
                        <div className="col-md-6">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="box_seat">
                                            <div className="top_seat">
                                                <h4>Lower deck</h4>
                                                <img src="/assets/images/bus/car.png" alt="bus" />
                                            </div>

                                            <div className="seat-grid">
                                                {lowerDeck.map((seat) => {
                                                    const isBooked = seat.status === 4;

                                                    return (
                                                        <div
                                                            key={seat.id}
                                                            className={`seat ${isBooked ? "booked" : "available"}`}
                                                            style={{
                                                                gridColumn: seat.x + 1,
                                                                gridRow: seat.y + 1,
                                                            }}
                                                        >
                                                            {seat.name}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="box_seat">
                                            <div className="top_seat">
                                                <h4>Upper deck</h4>
                                            </div>

                                            <div className="seat-grid">
                                                {upperDeck.map((seat) => {
                                                    const isBooked = seat.status === 4;

                                                    return (
                                                        <div
                                                            key={seat.id}
                                                            className={`seat ${isBooked ? "booked" : "available"}`}
                                                            style={{
                                                                gridColumn: seat.x + 1,
                                                                gridRow: seat.y + 1,
                                                            }}
                                                        >
                                                            {seat.name}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 know_app">
                                <h6>Know your seat types</h6>
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Seat Types</th>
                                            <th>Seater</th>
                                            <th>Sleeper</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Available</td>
                                            <td> <img src="/assets/images/seater_available.png" /> </td>
                                            <td> <img src="/assets/images/sl_available.png" /> </td>

                                        </tr>
                                        <tr>
                                            <td>Available only for male passenger</td>
                                            <td> <img src="/assets/images/seater_male.png" /> </td>
                                            <td> <img src="/assets/images/sl_male.png" /> </td>
                                        </tr>
                                        <tr>
                                            <td>Already booked</td>
                                            <td> <img src="/assets/images/seater_booked.png" /> </td>
                                            <td> <img src="/assets/images/sl_booked.png" /> </td>
                                        </tr>
                                        <tr>
                                            <td>Selected by you</td>
                                            <td> <img src="/assets/images/seater_selected.png" /> </td>
                                            <td> <img src="/assets/images/sl_selected.png" /> </td>
                                        </tr>
                                        <tr>
                                            <td>Available only for female passenger</td>
                                            <td> <img src="/assets/images/seater_fem.png" /> </td>
                                            <td> <img src="/assets/images/sl_fem.png" /> </td>
                                        </tr>
                                        <tr>
                                            <td>Booked by female passenger</td>
                                            <td> <img src="/assets/images/seater_fem2.png" /> </td>
                                            <td> <img src="/assets/images/sl_fem2.png" /> </td>
                                        </tr>
                                        <tr>
                                            <td>Booked by male passenger</td>
                                            <td> <img src="/assets/images/seat-male-blocked.png" /> </td>
                                            <td> <img src="/assets/images/sl-male-blocked.png" /> </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="col-md-12">
                                <div className="rop_right">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="text_info">
                                                <h6>{bus?.name}</h6>
                                                <p>{bus?.type}</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="text_info">
                                                <p className="seatNo">
                                                    <span>3A</span>
                                                </p>
                                                 <h4>₹ {fare?.total}</h4>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="price_box">                                               
                                                <button className="btn btn-primary">Continue</button>
                                            </div>
                                        </div>
                                    </div>

                                   
                                    

                                    <div className="BusImage">
                                        <Swiper modules={[Navigation, Autoplay]}
                                            spaceBetween={10}
                                            slidesPerView={1.5}
                                            navigation
                                            autoplay={{ delay: 332000 }}
                                            loop={true}>
                                            <SwiperSlide>
                                                <div className="item-swipler">
                                                    <img src="/assets/images/bus/bus-1.jpeg" alt="bus" />
                                                </div>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <div className="item-swipler">
                                                    <img src="/assets/images/bus/bus-2.jpeg" alt="bus" />
                                                </div>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <div className="item-swipler">
                                                    <img src="/assets/images/bus/bus-3.jpeg" alt="bus" />
                                                </div>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <div className="item-swipler">
                                                    <img src="/assets/images/bus/bus-4.jpeg" alt="bus" />
                                                </div>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <div className="item-swipler">
                                                    <img src="/assets/images/bus/bus-5.jpeg" alt="bus" />
                                                </div>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <div className="item-swipler">
                                                    <img src="/assets/images/bus/bus-6.jpeg" alt="bus" />
                                                </div>
                                            </SwiperSlide>

                                        </Swiper>






                                    </div>
                                    <div className="why_book_this">
                                        <ul class="nav nav-tabs bus_details">
                                            {/* <li class="nav-item">
                                        <a class="nav-link active" data-bs-toggle="tab" href="#Whybook">Why us?</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-bs-toggle="tab" href="#Busroute">Bus route</a>
                                    </li> */}
                                            <li class="nav-item">
                                                <a class="nav-link active" data-bs-toggle="tab" href="#Boardingpoint">Boarding point</a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" data-bs-toggle="tab" href="#Droppingpoint">Dropping point</a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" data-bs-toggle="tab" href="#amenities">amenities</a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" data-bs-toggle="tab" href="#OtherPolicies">Policies</a>
                                            </li>

                                        </ul>
                                        <div class="tab-content">
                                            {/* <div id="Whybook" class="tab-pane active">
                                        <div className="bus_tab-content">
                                            <h5>Why book this bus?</h5>
                                            <h6><i className="fa fa-bus"></i> Women Traveling</h6>
                                            <p></p>

                                            <h6><i className="fa fa-bus"></i> Highly rated by women</h6>
                                            <p></p>

                                            <h6><i className="fa fa-bus"></i> Lounge</h6>
                                            <p></p>

                                            <h6><i className="fa fa-bus"></i> Live Tracking</h6>
                                            <p>You can now track your bus and plan your commute to the boarding point!Family members and friends can also check the bus location to
                                                coordinate pick-ups and rest assured about your safety.</p>


                                        </div>

                                    </div>
                                    <div id="Busroute" class="tab-pane fade">
                                        <div className="bus_tab-content">
                                            <h5>Bus route</h5>
                                            <h6>Duration : <span style={{ color: "red" }}> 13 hr 10 min</span></h6>
                                            <p>
                                                <span><strong>Delhi</strong> <i className="fa fa-arrow-right"></i></span>
                                                <span>Mathura <i className="fa fa-arrow-right"></i> </span>
                                                <span>Agra<i className="fa fa-arrow-right"></i></span>
                                                <span>Lucknow<i className="fa fa-arrow-right"></i></span>
                                                <span>Faizabad<i className="fa fa-arrow-right"></i></span>
                                                <span>Ayodhya<i className="fa fa-arrow-right"></i></span>
                                                <span>Basti<i className="fa fa-arrow-right"></i></span>
                                                <span>Ayodhya<i className="fa fa-arrow-right"></i></span>
                                                <span>Khalilabad<i className="fa fa-arrow-right"></i></span>
                                                <span><strong>Gorakhpur (uttar pradesh)</strong> </span>
                                            </p>
                                        </div>
                                    </div> */}
                                            <div id="Boardingpoint" class="tab-pane active">
                                                <div className="bus_tab-content">
                                                    {bus?.boarding?.map((b, i) => (
                                                        <>
                                                         <div className="d-buse-bus" key={i}>
                                                           
                                                        <div className="point_dops">
                                                            <h4>{formatTime(b.time)}</h4>
                                                            <p>{formatDate(b.time)}</p>
                                                        </div>
                                                        <div className="dot_pont"> <span></span> </div>
                                                        <div className="point_dop">
                                                            <h4>{b.name}</h4>
                                                            <p>{b.name}</p>
                                                        </div>
                                                    </div>
                                                        </>
                                                        
                                                    ))}                                                  
                                                   
                                                </div>
                                            </div>
                                            <div id="Droppingpoint" class="tab-pane fade">
                                                <div className="bus_tab-content">
                                                    {bus?.dropping?.map((d, i) => (
                                                        <>
                                                         <div className="d-buse-bus" key={i}>
                                                        <div className="point_dops">
                                                            <h4>{formatTime(d.time)}</h4>
                                                            <p>{formatDate(d.time)}</p>
                                                        </div>
                                                        <div className="dot_pont"> <span></span> </div>
                                                        <div className="point_dop">
                                                            <h4>{d.name}</h4>
                                                            <p>{d.name}</p>
                                                        </div>
                                                    </div>
                                                        </>
                                                       
                                                    ))}
                                                   
                                                </div>
                                            </div>
                                            <div id="amenities" class="tab-pane fade">
                                                <div className="bus_tab-content ro_amitis">
                                                   
                                                    {bus?.amenities?.map((a, i) => (
                                                        <p key={i}>✔ {a}</p>
                                                    ))}
                                                    

                                                </div>
                                            </div>
                                            <div id="OtherPolicies" class="tab-pane fade">
                                                <div className="bus_tab-content">
                                                    <table className="table table-bordered">
                                                        <tbody>
                                                            {policy.map((p, i) => (
                                                                <tr key={i}>
                                                                    <td>{p.span}</td>
                                                                    <td>{p.rate}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>



                </div>
            </section>
        </div>
    );
};

export default SeatLayout;